import HtmlSummary from 'components/global/application/HtmlSummary';
import { BREAK_POINT } from 'constants/responsive';
import React from 'react';
import './VintageGuitarsListingItem.sass';

interface Props {
    className?: string;
    title: string;
    descriptionHml: string;
    url: string;
}

const VintageGuitarsListingItem: React.StatelessComponent<Props> = (props: Props) => {
    const isMobile = window.innerWidth < BREAK_POINT;
    return(
        <div className={`VintageGuitarsListingItem-container${isMobile ? '-mobile' : ''}${props.className ? ` ${props.className}` : ''}`}>
            <div className="Info">
                <h3><a href={props.url}>{props.title}</a></h3>
                {!isMobile && <HtmlSummary htmlContent={props.descriptionHml} lines={3}/>}
                <span className="Read-more"><a href={props.url}>Read More</a></span>
            </div>
        </div>
    );
};

export default VintageGuitarsListingItem;



// WEBPACK FOOTER //
// ./src/components/pages/vintageGuitars/VintageGuitarsListingItem.tsx